export const filterActivityViewDataRequests = (envelope) => {
    const FILTER_OPERATION_NAMES = [
        'GET ActivityView [hash]',
        'GET TodayPlus [hash]',
    ];

    if (envelope.baseType !== 'RemoteDependencyData') {
        return true; // keep non dependency telemetry
    }

    const operationName = envelope.tags && envelope.tags['ai.operation.name'];
    const isFilteredOperation = FILTER_OPERATION_NAMES.includes(operationName);
    const responseCodeRaw = envelope.baseData && envelope.baseData.responseCode;
    const responseCode = typeof responseCodeRaw === 'string' ? parseInt(responseCodeRaw, 10) : responseCodeRaw;
    const isSuccessful = typeof responseCode === 'number' && responseCode >= 200 && responseCode < 300; // any 2xx

    // Drop telemetry only when operation matches and request succeeded.
    return !(isFilteredOperation && isSuccessful);
};
